import { createSelector } from 'reselect';

const data = (state) => state.maintenanceRequestData;

export const selectFilterData = () => createSelector([data], (state) => state.filter);

export const selectFilterCriteriaData = () =>
  createSelector([data], (state) => state.filterCriteria);

export const selectCurrentRequestData = () =>
  createSelector([data], (state) => state.currentRequest);
